export const userIsSwipingLeft = (eventMovementX) => {
  return eventMovementX < 0
}

export const userIsSwipingRight = (eventMovementX) => {
  return eventMovementX > 0
}

export const getAbsoluteMovementX = (eventMovementX, eventClientX, lastClientX) => {
  // to avoid handling positive and negative cases we use absolute value to calculate distance
  eventMovementX = Math.abs(eventMovementX)

  // custom solution - for some reason safari returns like 8 times smaller movementX value than other browsers
  // that is why we have to store last known clientX value to calculate actual movement X value at the next event
  if(lastClientX !== null) {
      const calculatedEventMovementX = Math.abs(lastClientX - eventClientX)
      eventMovementX = calculatedEventMovementX
  } else {
      eventMovementX = 0
  }

  return eventMovementX
}
